import Feature6 from './Feature6'
export default Feature6
